import { BusinessTypes } from '../../../constants/Enums';

export const dummyDayparts = () => {
    return [
        { name: 'Overnight' },
        { name: 'Breakfast' },
        { name: 'Morning' },
        { name: 'Afternoon' },
        { name: 'Drive' },
        { name: 'Evening' }
    ];
};

export const dummyCampaignGoals = () => {
    return [
        { id: 0, name: 'Most Natural' },
        { id: 1, name: 'Highest OTH' },
        { id: 2, name: 'Highest Target Impacts' },
        { id: 3, name: 'Highest Reach' },
        { id: 4, name: 'Highest Base Impacts' },
        { id: 5, name: 'Lowest CPT' },
        { id: 6, name: 'Overall Target OTH' },
        { id: 7, name: 'Overall Base OTH' }
    ];
};

export const monthShort = (monthNum) => {
    const monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return monthNum >= 0 && monthNum < 12 ? monthList[monthNum] : 'Unk';
};

export const weekdaysShort = (weekNum) => {
    const weekList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return weekNum >= 0 && weekNum < 7 ? weekList[weekNum] : 'Unk';
};

export const digitFormat = (d) => {
    if (d) {
        if (d.toString().includes('.')) {
            d = d.toFixed(2);
        }
    }
    if (d < 10) {
        return `0${d}`;
    } else {
        return d;
    }
};

export const digitCommaFormat = (d) => {
    if (d) {
        return Math.round(d)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return d;
};

export const airtimePlanningInputState = (campaign) => {
    const state = { stepCompleted: false, stepEdited: false };

    // ToDo: include other statuses as required
    if (campaign.currentPlan) {
        state.stepCompleted = true;
        state.stepEdited = true;
    }

    // ToDo: add any further checks required

    return state;
};

export const addDays = (dtDate, dayOffSet) => {
    if (dtDate) {
        const dtDateCopy = new Date(dtDate);
        const dt = new Date(Number(dtDateCopy));
        dt.setDate(dtDateCopy.getDate() + dayOffSet);
        return dt;
    }
    return dtDate;
};
